import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { ConfirmationComponent } from '@bca-confirmation/confirmation/confirmation.component';
import { SharedModule } from '@bca-shared/shared.module';
import { VerifyModule } from '@bca-verify/verify.module';
import { TabStepperModule } from '../bca-flow/bca-flow-window/tab-stepper/tab-stepper.module';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [ConfirmationComponent],
  imports: [CommonModule, SharedModule, ReactiveFormsModule, VerifyModule, TabStepperModule, TranslateModule.forChild()],
  exports: [ConfirmationComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ConfirmationModule {}
